import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    lang: {
      en: { 
        menu: {
          0 : 'Home',
          1 : 'Rooms',
          2 : 'About Us',
          3 : 'Contact Us',
          4 : 'Menu',
          5 : 'Close'
        },
        home: {
          0 : 'Live the',
          1 : 'Experience',
          2 : 'Single Room',
          3 : 'Double Room',
          4 : 'Cozy room for one person, with a queen bed, air conditioner, private bathroom, hot water, mini fridge with complimentary drinks, among other amenities.',
          5 : 'Comfortable room for two, with two full beds, air conditioner, private bathroom, hot water, mini fridge with complimentary drinks, among other amenities.',
          
          6 : 'Start and end date',
          
          7 : 'Month',
          8 : 'Nights',
          9 : 'People',
          10 : 'Book',
          11 : 'Rooms',
          12 : 'More information',
          13 : 'About Us',
          14 : 'Contact Us',
          15 : 'Avenida Miramar Barrios Las Peñas, Acajutla, Sonsonate.',
          16 : 'Name',
          17 : 'Telephone',
          18 : 'Message',
          19 : 'Send',
          20 : 'With the support of the ministry of economy.'
        },
        about:{
          0 : 'About Us',
          1 : 'More About Villavela',
          2 : 'Villavela was conceived at the request of our clients to stay near Acajutla´s port in a place where they felt at home, with all the comforts that you´ll only find here; From the infrastructure to the service, every detail will make your stay unique. The hotel is located in the house where the Acajutla Restaurant began more than 30 years ago, which has been owned by the family since the 1950s. With a privileged location as it is located a few minutes from the Industrial Zone of the Port of Acajutla, it is the ideal place to stay.',
          3 : 'Villavela has a modern contemporary décor, but maintains the essence of the property of the 50s: combination of exposed brick, with natural wood.',
          4 : 'All rooms have all the necessary amenities to make your stay the most comfortable:',
          5 : 'Breakfast included',
          6 : 'Air Conditioning',
          7 : 'Private bathroom',
          8 : 'Hot water',
          9 : 'Wireless Internet',
          10 : 'Cable TV',
          11 : 'Mini fridge with complimentary drinks',
          12 : 'Guests can enjoy up to 15% discount on their consumption at Restaurante Acajutla. In addition, the hotel has a swimming pool in case you want to sunbathe or just relax for a moment.'

        },
        room:{
          0 : 'Single Room',
          1 : 'Double Room',
          2 : 'Opening',
          3 : 'Night',
          
          4 : 'Cozy room for one person with the following amenities:',
          5 : 'One queen bed',
          6 : 'A la carte breakfast for one.',
          7 : 'Air Conditioner.',
          8 : 'Private Bathroom.',
          9 : 'Hot Water.',
          10 : 'Wireless Internet.',
          11 : 'elevisión with cable.',
          12 : 'Mini Fridge with complimentary drinks.',
          13 : '15% discount at Restaurante Acajutla when paying in cash and 10% when paying with credit or debit card.',

          14 : 'Check In: 3:00 p.m.',
          15 : 'Check Out: 12:00 p.m.',
          
          16 : 'Comfortable room for two with the following amenities:',
          17 : 'Two full beds.',
          18 : 'A la carte breakfast for two.',
          19 : 'Air Conditioner.',
          20 : 'Private Bathroom.',
          21 : 'Hot Water.',
          22 : 'Wireless Internet.',
          23 : 'elevisión with cable.',
          24 : 'Mini Fridge with complimentary drinks.',
          25 : '15% discount at Restaurante Acajutla when paying in cash and 10% when paying with credit or debit card.',
          
          26 : 'Book',

          27 : 'price',
          28: '* The price does not include tax charge.',

          29: 'Confirm',

          30: 'From'
        }
      },
      es:{
        menu: {
          0 : 'Inicio',
          1 : 'Habitaciones',
          2 : 'Nosotros',
          3 : 'Contáctanos',
          4 : 'Menú',
          5 : 'Cerrar'
        },
        home: {
          0 : 'Vive la',
          1 : 'Experiencia',
          2 : 'Habitación Sencilla',
          3 : 'Habitación Doble',
          4 : 'Habitación acogedora para una persona con cama queen, aire acondicionado, baño privado, agua caliente y refrigeradora con bebidas de cortesía para hacer tu estadía más cómoda, entre otras amenidades.',
          5 : 'Habitación sumamente cómoda para dos personas. Cuenta con dos camas full, aire acondicionado, baño privado, agua caliente y refrigeradora con bebidas de cortesía para hacer tu estadía más cómoda, entre otras amenidades.',
          
          6 : 'Fecha de llegada y salida',

          7 : 'Mes',
          8 : 'Estadía',
          9 : 'Personas',
          10 : 'Reservar',
          11 : 'Habitaciones',
          12 : 'Ver más',
          13 : 'Conócenos',
          14 : 'Contáctanos',
          15 : 'Avenida Miramar Barrios Las Peñas, Acajutla, Sonsonate.',
          16 : 'Nombre',
          17 : 'Teléfono',
          18 : 'Mensaje',
          19 : 'Enviar',
          20 : 'Con el apoyo del ministerio de economia.'
        },
        about:{
          0 : 'Nosotros',
          1 : 'Más sobre Villavela',
          2 : 'Villavela nace a petición de nuestros clientes para hospedarse en la zona portuaria donde se sintieran como en casa, con todas las comodidades que solo aquí encontrarás; desde la infraestructura hasta la atención harán tu estadía única. El hotel está situado en la casa donde comenzó el Restaurante Acajutla hace más de 30 años, la cual ha sido propiedad de la familia desde los años 50. Con una ubicación privilegiada ya que se encuentra a pocos minutos de la Zona Industrial del Puerto de Acajutla, es el lugar ideal para hospedarte.',
          3 : 'Villavela cuenta con una decoración moderna contemporánea, pero mantiene la esencia de las propiedades de los años 50s: combinación de ladrillo visto, con madera natural.',
          4 : 'Sus habitaciones cuentan con todas las amenidades necesarias para hacer de tu estadía la más cómoda:',
          5 : 'Desayuno incluido',
          6 : 'Aire Acondicionado',
          7 : 'Baño privado',
          8 : 'Agua caliente',
          9 : 'Internet Inalámbrico',
          10 : 'Televisión con cable',
          11 : 'Mini refrigeradora con bebidas de cortesía',
          12 : 'Los huéspedes podrán disfrutar hasta un 15% de descuento en su consumo en Restaurante Acajutla. Adicionalmente, el hotel cuenta con una piscina en caso desees tomar el sol o simplemente relajarte un momento.',
        },
        room:{
          0 : 'Habitación Sencilla',
          1 : 'Habitación Doble',
          2 : 'Precio',
          3 : 'Noche',

          4 : 'Habitación acogedora para una persona. Cuenta con las siguientes amenidades:',
          5 : 'Una cama queen.',
          6 : 'Desayuno a la carta para una persona.',
          7 : 'Aire Acondicionado.',
          8 : 'Baño Privado.',
          9 : 'Agua Caliente.',
          10 : 'Internet Inalámbrico.',
          11 : 'Televisión con cable.',
          12 : 'Mini Refrigeradora con bebidas de cortesía.',
          13 : '15% de descuento en consumo en Restaurante Acajutla al pagar en efectivo y 10% al pagar con tarjeta.',

          14 : 'Entrada: 3:00 p.m.',
          15 : 'Salida: 12:00 p.m.',
          
          16 : 'Habitación sumamente cómoda para dos personas. Cuenta con las siguientes amenidades:',
          17 : 'Dos camas full.',
          18 : 'Desayuno a la carta para dos personas.',
          19 : 'Aire Acondicionado.',
          20 : 'Baño Privado.',
          21 : 'Agua Caliente.',
          22 : 'Internet Inalámbrico.',
          23 : 'Televisión con cable.',
          24 : 'Mini Refrigeradora con bebidas de cortesía.',
          25 : '15% de descuento en consumo en Restaurante Acajutla al pagar en efectivo y 10% al pagar con tarjeta.',
          26 : 'Reservar',
          27 : 'Precio',
          28: '* El precio no incluye cargo de impuesto.',
          29: 'Confirme',
          30: 'Desde'
        }
      }
    }
  },
  mutations: {
    change(){
      console.log(this.$route.params.lang)
    }
  },
  actions: {

  }
})
